// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".images[data-v-2b0442fe] {\n  opacity: 0;\n  position: absolute;\n  width: 54px;\n  height: 27px;\n  left: 3px;\n}\n.detail-centent[data-v-2b0442fe] {\n  line-height: 30px;\n  font-size: 14px;\n}\na[data-v-2b0442fe] {\n  color: var(--prev-color-primary);\n}", ""]);
// Exports
module.exports = exports;
